import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Callback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");

    if (code) {
      // Exchange the code for an access token (you'll need a backend for this)
      console.log("Authorization code:", code);

      // Exchange the authorization code for an access token
      fetch("https://soundtrackd-worker.stefangawrys-cloudflare.workers.dev/api/spotify/codeExchange?code=" + code)
        .then((res) => {
          if (!res.ok) {
            throw new Error("Failed to fetch access token");
          }
          return res.json(); // Parse the response as JSON
        })
        .then((data) => {
          // Store the access token in app state (e.g., using React Context, Redux, or local state)
          // Example: Using localStorage for simplicity
          localStorage.setItem("spotifyAccessToken", data.access_token);
        
          const setCookie = (name, value, days) => {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
            const expires = `expires=${date.toUTCString()}`;
            document.cookie = `${name}=${value};${expires};path=/`;
          };

          setCookie("spotifyAccessToken", data.access_token, 1);

          navigate('/playlists');
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      console.error("No authorization code found.");
    }
  }, [location, navigate]);

  return <div>Loading...</div>;
};

export default Callback;
